
import React, {Fragment, useState} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {FacebookEmbed, LinkedInEmbed, XEmbed, YouTubeEmbed} from "react-social-media-embed";
import {SocialIcon} from 'react-social-icons'

const RightDashboard = () => {
    const [key, setKey] = useState(0);

    const handleReload = () => {
        setKey(prevKey => prevKey + 1);
    };

    return (
        <Fragment>
            <div className="xxx">
                <div className="">
                    <br/>
                    <button class="my-button" onClick={handleReload}>Back</button>
                    {/* Embedding the URL as an iframe */}
                    <div id="iframe-container" className="iframe-container">
                    	{/*removed fool class*/}
                        <iframe
                            key={key}
                            src="https://farelanes.com/news-embed/?embedded=true"
                            title="Farelanes Report"
                            allowFullScreen
                            scrolling="no"
                        ></iframe>
                    </div>
                </div>
                <br/>
            </div>
        </Fragment>
    );
};

export default RightDashboard;